module.exports = __webpack_public_path__ + "img/ch78.d924b20c.jpg";